var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 10.666L4.66675 7.33268L5.60008 6.36602L7.33342 8.09935V2.66602H8.66675V8.09935L10.4001 6.36602L11.3334 7.33268L8.00008 10.666ZM4.00008 13.3327C3.63341 13.3327 3.31964 13.2022 3.05875 12.9413C2.79786 12.6805 2.66719 12.3665 2.66675 11.9993V9.99935H4.00008V11.9993H12.0001V9.99935H13.3334V11.9993C13.3334 12.366 13.203 12.68 12.9421 12.9413C12.6812 13.2027 12.3672 13.3331 12.0001 13.3327H4.00008Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsDownload);
export default __webpack_public_path__ + "static/media/material-symbols_download.43b5ccd856b6d78ffccbc30be9d071c5.svg";
export { ForwardRef as ReactComponent };